import companyInfo from '../themes/themes';

export const providerName = companyInfo[process.env.REACT_APP_THEME].company;
